import { Module } from 'wrapper6'

const $ = jQuery

export default class BMICalculator extends Module {
  ready (app) {
    // get page title
    const hiddenTitle = $('.hiddenTitle').text()
    // insert title in input field
    $('#field_y3ccs9').val(hiddenTitle)
    $('#frm_field_81_container').hide()
    // bmi calculator
    $(document).on('click', '#bmi-calculator button', () => {
      let height = $('#bmi-calculator').find('#height').val()
      let weight = $('#bmi-calculator').find('#weight').val()
      if (parseFloat(height) > 10) {
        height = (height / 100) + ''
      }
      height = parseFloat(height.replace(',', '.'))
      weight = parseFloat(weight.replace(',', '.'))
      const result = parseFloat(weight / (height * height)).toFixed(2)
      if (height && weight) {
        $('#result').html('Dit BMI er: ' + result)
        $('#result').addClass('success').removeClass('failed')
        this.addValueToForm(result)
      } else {
        $('#result').html('Udfyld venligst begge felter.')
        $('#result').addClass('failed').removeClass('success')
      }
    })
  }

  addValueToForm (result) {
    const BMI = document.querySelector('#bmi-field')
    if (result && BMI) {
      BMI.value = result
    }
  }
}



// WEBPACK FOOTER //
// ./resources/js/modules/_bmi-calculator.js